module.exports = __webpack_public_path__ + "img/micronesia.1583da1f.svg";